import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { getStockQuantity } from '@/src/lib/stock-quantity/requests/get-stock-quantity';
export function useStockQuantity(sku) {
  const $ = _c(2);
  let t0;
  if ($[0] !== sku) {
    t0 = {
      mutationFn: getStockQuantity,
      mutationKey: ["stock-quantity", sku]
    };
    $[0] = sku;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}